import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="bg-gray-800 text-white py-8">
    <div className="container mx-auto text-center">
      <div className="text-sm text-gray-400 flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        <span>&copy; Shoval Saada coach career. All rights reserved.</span>
        <span className="text-gray-600">·</span>
        <Link to="/terms" className="underline hover:text-white transition-colors">
          Terms of Service
        </Link>
        <span className="text-gray-600">·</span>
        <Link to="/privacy" className="underline hover:text-white transition-colors">
          Privacy Notice
        </Link>
        <span className="text-gray-600">·</span>
        <Link to="/refund" className="underline hover:text-white transition-colors">
          Refund Policy
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
